import { createOnlineStatusApi } from './online-status.api.http';

export const myOnlineStatusApi = createOnlineStatusApi();
